/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-29 19:45:19
 * @LastEditors: linxi
 * @LastEditTime: 2024-03-08 09:18:41
 */
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Pagination,
  Row,
  Select,
  Table,
} from "antd";
import { DateSelect, StoreSearchRecentTimes } from "../../../../compnents/form/DateSelect";
import { CaretDownOutlined, SearchOutlined } from "@ant-design/icons";
import styles from "./additionDrug.module.css";
import {
  getMintenanceResultName,
  getMintenanceStepName,
  getQualityOfCommunityName,
  MintenanceResults,
  MintenanceStepS,
  QualityOfCommunities,
} from "../../../../models/maintenance";
import { MaintenanceDurg } from "./column";
import { useDispatch, useSelector } from "react-redux";
import {
  getModalDurg,
  SaveAllDurgAsync,
  selectModalCurrent,
  selectModalData,
  selectModalTotal,
  setModalCurrent,
  submitDurgAsync,
} from "./addtionDrugSlice";
import { ModalDurgParams } from "../../../../services/addtionDrug";
import {
  getMaterialsCategoryName,
  MaterialsCategories,
} from "../../../../models/commodity";
import { DataType } from "../../../putstorage/putstorage";
import { useLocation } from "react-router";
import { RootDispatch } from "../../../../app/store";
import { unwrapResult } from "@reduxjs/toolkit";
import { EditableList } from "../../../../compnents/list/EditableList";
const { Option } = Select;

export const MintenanceModule = (props: {
  tenantMaintainId: number;
  maintainCategory: number;
  storehouseId: number;
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}) => {
  const location: any = useLocation();

  const dispatch = useDispatch<RootDispatch>();

  const [formMaintenance] = Form.useForm();

  const [form] = Form.useForm();

  const data = useSelector(selectModalData);

  const current = useSelector(selectModalCurrent);

  const total = useSelector(selectModalTotal);

  const [size, setSize] = useState(10);

  const [queries, setQueries] = useState<ModalDurgParams>({
    maintainCategory: props.maintainCategory,
  });

  const [selectRow, setSelectRow] = useState<any>([]);

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      setSelectRow(
        selectedRows.map((v) => {
          return {
            ...v,
            ...formMaintenance.getFieldsValue(),
            maintainMeasure: JSON.stringify(
              formMaintenance.getFieldsValue().maintainMeasure
            ),
            tenantMaintainId: props.tenantMaintainId,
          };
        })
      );
    },
  };

  useEffect(() => {
    formMaintenance.setFieldsValue({
      maintainMeasure: [0],
      maintainQuality: 0,
      maintainResult: 0,
    });
  }, []);

  useEffect(() => {
    if (props.visible) {
      form.setFieldsValue({
        maintainCategory: props.maintainCategory,
      });
      setQueries({
        maintainCategory: props.maintainCategory,
      });
    }
  }, [props.visible, props.maintainCategory]);

  useEffect(() => {
    if (props.storehouseId || props.maintainCategory) {
      dispatch(
        getModalDurg({
          ...queries,
          size,
          current,
          storehouseId: props.storehouseId,
        })
      );
    }
  }, [queries, size, current, props.storehouseId, props.maintainCategory]);

  return (
    <Modal
      visible={props.visible}
      title="添加养护药品"
      okText="确认"
      cancelText="取消"
      className={styles.Modal}
      bodyStyle={{ height: "670px", padding: '20px',overflow:'hidden' }}
      onOk={() => {
        props.onOk();
      }}
      onCancel={() => {
        props.onCancel();
        setSelectRow([])
      }}
      footer={null}
    >
      {/* <Row gutter={10} style={{ marginBottom: "10px" }}>
        <Col span={3}>
          <Button type="primary" style={{ width: "100%" }}>
            添加勾选药品
          </Button>
        </Col>
        <Col span={3}>
          <Button type="primary" style={{ width: "100%" }}>
            添加全部药品
          </Button>
        </Col>
      </Row> */}
      <Form
        form={formMaintenance}
        onFieldsChange={() => {
          setSelectRow(
            selectRow.map((v: any) => {
              return {
                ...v,
                ...formMaintenance.getFieldsValue(),
                maintainMeasure: JSON.stringify(
                  formMaintenance.getFieldsValue().maintainMeasure
                ),
                tenantMaintainId: props.tenantMaintainId,
              };
            })
          );
        }}
      >
        <Row gutter={40} style={{ height: "46px" }}>
          <Col span={8}>
            <Form.Item name="maintainMeasure" label="养护措施">
              <Select
                mode="multiple"
                className={styles.multiple}
                allowClear
              // suffixIcon={<CaretDownOutlined />}
              >
                {MintenanceStepS.map((v) => (
                  <Option key={v} value={v}>
                    {getMintenanceStepName(v)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="maintainQuality" label="质量状况">
              <Select>
                {QualityOfCommunities.map((v) => (
                  <Option key={v} value={v}>
                    {getQualityOfCommunityName(v)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="maintainResult" label="养护结果">
              <Select>
                {MintenanceResults.map((v) => (
                  <Option key={v} value={v}>
                    {getMintenanceResultName(v)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Form
        form={form}
        onFieldsChange={() => {
          setQueries({ ...form.getFieldsValue() });
          dispatch(setModalCurrent(1))
        }}
      >
        <Row
          gutter={11}
          style={{ height: "42px", position: "relative", zIndex: 999 }}
          wrap={false}
        >
          <Col span={5}>
            <Form.Item name="name">
              <Input
                placeholder="请输入药品名称或助记码"
                allowClear
                prefix={<SearchOutlined />}
              />
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item name="materialsCategory">
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                placeholder="药品类别"
                allowClear
              >
                {MaterialsCategories.map((v) => (
                  <Option value={v} key={v}>
                    {getMaterialsCategoryName(v)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item name="maintainCategory">
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                placeholder="目录养护等级"
                allowClear
              >
                <Option value={-1}>全部</Option>
                <Option value={0}>一般养护</Option>
                <Option value={1}>重点养护</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <DateSelect
              style={{ width: '100%' }}
              placeholder='有效期至'
              allowClear={false}
              labelPrefix=''
              options={StoreSearchRecentTimes}
              namePrefix='registrationTime'
              onChange={() => {
                const { registrationTimeHead, registrationTimeTail, maintainCategory, ...rest } = form.getFieldsValue();
                setQueries({
                  ...rest,
                  deadlineStart: registrationTimeHead ?? undefined,
                  deadlineEnd: registrationTimeTail ?? undefined,
                  maintainCategory: maintainCategory === -1 ? undefined : maintainCategory,
                });
                dispatch(setModalCurrent(1));
              }}
            />
          </Col>
          <Col span={2}>
            <Button
              htmlType="submit"
              type="primary"
              style={{ width: "100%", float: "right" }}
              onClick={() => {
                const { registrationTimeHead, registrationTimeTail, maintainCategory, ...rest } = form.getFieldsValue();
                setQueries({
                  ...rest,
                  deadlineStart: registrationTimeHead ?? undefined,
                  deadlineEnd: registrationTimeTail ?? undefined,
                  maintainCategory: maintainCategory === -1 ? undefined : maintainCategory,
                });
              }}
            >
              查询
            </Button>
          </Col>
          <Col span={3} offset={1}>
            <Button
              type="primary"
              style={{ width: "100%" }}
              onClick={() => {
                dispatch(submitDurgAsync(selectRow))
                  .then(unwrapResult)
                  .then(() => {
                    props.onOk();
                  });
              }}
            >
              添加勾选药品
            </Button>
          </Col>
          <Col span={3}>
            <Button
              type="primary"
              style={{ width: "100%" }}
              onClick={() => {
                const searchFormValues = form.getFieldsValue();
                const searchMaintainCategory = searchFormValues.maintainCategory;
                dispatch(
                  SaveAllDurgAsync({
                    ...formMaintenance.getFieldsValue(),
                    ...searchFormValues,
                    maintainMeasure: JSON.stringify(
                      formMaintenance.getFieldsValue().maintainMeasure
                    ),
                    storehouseId: props.storehouseId,
                    maintainCategory: searchMaintainCategory === -1 ? undefined : searchMaintainCategory,
                    tenantMaintainId: props.tenantMaintainId,
                  })
                )
                  .then(unwrapResult)
                  .then(() => {
                    props.onOk();
                  });
              }}
            >
              添加全部药品
            </Button>
          </Col>
        </Row>
      </Form>
      <div style={{ height: '83%'}}>
        <EditableList
          style={{ height: '94%' }}
          rowKey={(record: any) => record.tenantInventoryLedgerId}
          columns={MaintenanceDurg(size * (current - 1))}
          page={{
            items: data,
            total: total,
            current: current,
            size: size,
          }}
          rowSelection={{
            // type: selectionType,
            ...rowSelection,
            preserveSelectedRowKeys: true,
          }}
          pageSizeOptions={['10', '20', '50', '100', '500']}
          onChangePage={(current, size: any) => {
            setSize(size);
            dispatch(setModalCurrent(current));
          }}
        ></EditableList>
      </div>
    </Modal>
  );
};
